module.exports = __webpack_public_path__ + "assets/img/101.0e927065.png";